import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ADVERTISE_NAV } from '@/constants/testIds/advertise';

export function AdvertiseFooterNav({ onBack, onNext, nextLabel = 'Continue', nextDisabled = false, loading = false, showBack = true, secondaryAction, nextTestId }) {
  return (
    <div className="mt-8 flex items-center justify-between border-t border-slate-200 pt-6">
      {showBack ? (
        <Button type="button" variant="ghost" onClick={onBack} className="rounded-xl" data-testid={ADVERTISE_NAV.back}>
          <ChevronLeft size={16} className="mr-1" />Back
        </Button>
      ) : <span />}
      <div className="flex items-center gap-3">
        {secondaryAction}
        <Button type="button" onClick={onNext} disabled={nextDisabled || loading} className="rounded-xl" data-testid={nextTestId || ADVERTISE_NAV.next}>
          {loading ? <Loader2 size={16} className="mr-1 animate-spin" /> : null}
          {nextLabel}
          {!loading && <ChevronRight size={16} className="ml-1" />}
        </Button>
      </div>
    </div>
  );
}
